import Vue from 'vue';
import { getSwiper, getNouiSlider } from '../utils';
import gsap from 'gsap';
import '../../../node_modules/nouislider/distribute/nouislider.css';

Vue.component('battery-simulator-component-new', {
    props: {
        values: {
            type: Object,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            rangeSlider: null,
            rangeValues: null,
            acChargeTimes: [],
            dcChargeTimes: [],
        };
    },

    watch: {
        rangeValues: function (newVal, oldVal) {
            if (newVal[0] > '70%') {
                this.rangeSlider.set([70, newVal[1]]);
            } else {
                [this.values.ac].forEach((chargeTime) => {
                    let acTimes = [];
                    for (const [key, value] of Object.entries(chargeTime)) {
                        acTimes.push(
                            this.round(
                                this.values.ac[key].percentage[newVal[1]] -
                                    this.values.ac[key].percentage[newVal[0]],
                                1,
                            ),
                        );
                    }

                    this.acChargeTimes = acTimes;
                });

                [this.values.dc].forEach((chargeTime) => {
                    let dcTimes = [];
                    for (const [key, value] of Object.entries(chargeTime)) {
                        dcTimes.push(
                            this.round(
                                this.values.dc[key].percentage[newVal[1]] -
                                    this.values.dc[key].percentage[newVal[0]],
                                1,
                            ),
                        );
                    }

                    this.dcChargeTimes = dcTimes;
                });

                this.setTimeBlocks();
            }
        },
    },

    computed: {},

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    async mounted() {
        this.initSlider();
        await this.initMobileSwiper();

        [this.values.ac].forEach((chargeTime) => {
            let acTimes = [];
            for (const [key, value] of Object.entries(chargeTime)) {
                acTimes.push(
                    this.round(
                        this.values.ac[key].percentage[this.rangeValues[1]] -
                            this.values.ac[key].percentage[this.rangeValues[0]],
                        1,
                    ),
                );
            }

            this.acChargeTimes = acTimes;
        });

        [this.values.dc].forEach((chargeTime) => {
            let dcTimes = [];
            for (const [key, value] of Object.entries(chargeTime)) {
                dcTimes.push(
                    this.round(
                        this.values.dc[key].percentage[this.rangeValues[1]] -
                            this.values.dc[key].percentage[this.rangeValues[0]],
                        1,
                    ),
                );
            }

            this.dcChargeTimes = dcTimes;
        });

        this.setTimeBlocks();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        async initSlider() {
            const slider =
                '.battery-simulator__module__battery-slider .battery-slider';

            const { noUiSlider } = await getNouiSlider();
            this.rangeSlider = noUiSlider.create(slider, {
                // Create two timestamps to define a range.
                range: {
                    min: 0,
                    '15%': 15,
                    '30%': 30,
                    '50%': 50,
                    '70%': 70,
                    '80%': 80,
                    '90%': 90,
                    '95%': 95,
                    max: 100,
                },
                format: {
                    // 'to' the formatted value. Receives a number.
                    to: function (value) {
                        return value + '%';
                    },
                    // 'from' the formatted value.
                    // Receives a string, should return a number.
                    from: function (value) {
                        return Number(value);
                    },
                },
                snap: true,
                tooltips: true,
                connect: true,
                // Two more timestamps indicate the handle starting positions.
                start: [0, 80],
            });

            this.rangeValues = this.rangeSlider.get();

            this.rangeSlider.on('update', (values, handle) => {
                this.rangeValues = values;
            });
        },

        setTimeBlocks() {
            let acChargeBlocks = [];
            let dcChargeBlocks = [];

            [this.values.ac].forEach((chargeTime) => {
                let acBlocks = [];
                for (const [key, value] of Object.entries(chargeTime)) {
                    acBlocks.push(
                        this.$el.querySelector(
                            `.battery-simulator__ac-charging__statistic-block--${key}`,
                        ),
                    );
                }

                acChargeBlocks = acBlocks;
            });

            [this.values.dc].forEach((chargeTime) => {
                let dcBlocks = [];
                for (const [key, value] of Object.entries(chargeTime)) {
                    dcBlocks.push(
                        this.$el.querySelector(
                            `.battery-simulator__dc-charging__statistic-block--${key}`,
                        ),
                    );
                }

                dcChargeBlocks = dcBlocks;
            });

            acChargeBlocks.forEach((block, index) => {
                gsap.to(block, {
                    width: this.acChargeTimes[index] * 15,
                    duration: 0.6,
                });
            });

            dcChargeBlocks.forEach((block, index) => {
                gsap.to(block, {
                    width: (this.dcChargeTimes[index] / 60) * 15,
                    duration: 0.6,
                });
            });
        },

        round(value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        },
        async initMobileSwiper() {
            const swiperContainer =
                '.battery-simulator__mobile-swiper-container';

            const { Swiper } = await getSwiper();
            new Swiper(swiperContainer, {
                speed: 400,
                slidesPerView: 1.3,
                spaceBetween: 10,
                centeredSlides: true,
            });
        },
    },
});
